let config = {
  libraryUrl: 'https://shelter-library.uw-network.com/wp-json',
  // libraryUrl: 'http://sheltermed.local/wp-json',
};

let getAllCategories = async () => {
  // Fetch all categories.
  let endpoint = `${config.libraryUrl}/wp/v2/categories?per_page=100`;
  let response = await fetch(endpoint);
  let data = await response.json();
  // Remove the uncategorized category.
  data = data.filter((category) => category.name !== 'Uncategorized');
  return data;
};

let getGuidebooks = async () => {
  let endpoint = `${config.libraryUrl}/wp/v2/guidebook`;
  let response = await fetch(endpoint);
  let data = await response.json();
  return data;
};

let getSingleGuidebookChapter = async (slug) => {
  let endpoint = `${config.libraryUrl}/wp/v2/posts?slug=${slug}`;
  let response = await fetch(endpoint);
  let data = await response.json();
  return data;
};

let getGuidebookChaptersList = async (id) => {
  let endpoint = `${config.libraryUrl}/wp/v2/posts?guidebook=${id}&orderby=menu_order&order=asc&per_page=100`;
  let response = await fetch(endpoint);
  let data = await response.json();
  // Sort the chapters by the acf chapter_order field.
  data.sort((a, b) => {
    return a.acf.chapter_order - b.acf.chapter_order;
  });

  return data;
};

let getGuidebookIdFromSlug = async (slug) => {
  let endpoint = `${config.libraryUrl}/wp/v2/guidebook?slug=${slug}`;
  let response = await fetch(endpoint);
  let data = await response.json();
  return data;
};

let getGuidebookSlugsFromIds = async (arrayOfIds) => {
  let endpoint = `${config.libraryUrl}/wp/v2/guidebook?include=${arrayOfIds}`;
  let response = await fetch(endpoint);
  let data = await response.json();
  return data;
};

let getResources = async (arrayOfIDs) => {
  let endpoint = `${config.libraryUrl}/wp/v2/resource?include=${arrayOfIDs.join(
    ','
  )}`;
  let response = await fetch(endpoint);
  let data = await response.json();
  return data;
};

let getSingleResource = async (slug) => {
  let endpoint = `${config.libraryUrl}/wp/v2/resource?slug=${slug}&_embed=wp:term`;
  let response = await fetch(endpoint);
  let data = await response.json();
  return data;
};

let getChapters = async (slug) => {
  let id = await getGuidebookIdFromSlug(slug);

  if (id.length < 1) return [];
  let chapters = await getGuidebookChaptersList(id[0].id);
  return chapters;
};

let getFeaturedResources = async () => {
  let endpoint = `${config.libraryUrl}/wp/v2/resource?categories=17`;
  let response = await fetch(endpoint);
  let data = await response.json();
  return data;
};

let search = async ({
  searchValue,
  searchFilters = null,
  postType = 'post,resource',
  searchPage = '1',
  perPage = '12',
  sortBy = 'relevance',
}) => {
  let searchString = `${config.libraryUrl}/relevanssi/v1/search?keyword=${searchValue}&type=${postType}&page=${searchPage}&per_page=${perPage}&orderby=${sortBy}`;
  // Temporarily remove perPage and and page.
  // let searchString = `${config.libraryUrl}/relevanssi/v1/search?keyword=${searchValue}&type=${postType}&orderby=${sortBy}&per_page="100"`;
  if (searchFilters) {
    searchString += constructFilters(searchFilters);
  }
  let results = await fetch(searchString);
  // retrieve X-WP-TotalPages header
  let totalPages = results.headers.get('X-WP-TotalPages');
  let data = await results.json();

  return { data, totalPages };
};

let constructFilters = (stringOfIds) => {
  //&tax_query[relation]=AND&tax_query[0][taxonomy]=category&tax_query[0][field]=id&tax_query[0][terms]=3&tax_query[1][taxonomy]=category&tax_query[1][field]=id&tax_query[1][terms]=
  stringOfIds = stringOfIds.split(',');
  let filterString = '&tax_query[relation]=AND';
  stringOfIds.forEach((id, i) => {
    filterString += `&tax_query[${i}][taxonomy]=category&tax_query[${i}][field]=id&tax_query[${i}][terms]=${id}`;
  });
  return filterString;
};

let renderDate = (date) => {
  // return the date in Month, Year format
  return new Date(date).toLocaleString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });
};

let titleCaseAndUnSlugify = (slug) => {
  return slug
    .replace(/-/g, ' ')
    .replace(/\w\S*/g, (w) => w.replace(/^\w/, (c) => c.toUpperCase()));
};

let filterContentForAbsoluteLibraryUrls = (content) => {
  // 1. Find all library urls. They're shaped like this: http://www.uwsheltermedicine.com/library/ but with different root urls.
  // 1a. create a regex to match urls that have /library/ in them but capture the root url and all the rest of the url.
  // leave the trailing slash so we can match the root url.
  let libraryUrlRegex = /(https?:\/\/[^\/]+\/)library\//g;
  let matches = content.match(libraryUrlRegex);
  if (!matches) return content;

  // 1b. Loop through the matches and replace the absolute urls with the relative urls.
  matches.forEach((match) => {
    // Retain the slash at the end of the relative url.
    let relativeUrl = match.replace(/https?:\/\/[^\/]+\//, '/');
    content = content.replace(match, relativeUrl);
  });

  // 3. Return the content with the relative urls.
  return content;
};

export {
  getGuidebooks,
  getSingleGuidebookChapter,
  getGuidebookChaptersList,
  getGuidebookIdFromSlug,
  getGuidebookSlugsFromIds,
  getChapters,
  getResources,
  getSingleResource,
  getFeaturedResources,
  getAllCategories,
  search,
  renderDate,
  titleCaseAndUnSlugify,
  filterContentForAbsoluteLibraryUrls,
};
